module.exports = __webpack_public_path__ + "img/emoji_61.c22447e5.png";